import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { PaywallLock } from '../paywall-lock'
import { UpdatePaymentInfoLock_OfferLockDataFragment } from './__generated__/update-payment-info-lock.graphql'
import { Content } from './content'
import { ModalLock } from './modal-lock'

interface UpdatePaymentInfoLockProps {
  offerLockData: UpdatePaymentInfoLock_OfferLockDataFragment
}

export function UpdatePaymentInfoLock({ offerLockData }: UpdatePaymentInfoLockProps) {
  const { componentType } = useContext(BoxLockContext)

  const content = <Content offerLockData={offerLockData} />

  switch (componentType) {
    case 'paywall':
      return <PaywallLock offerLockData={offerLockData}>{content}</PaywallLock>
    case 'modal':
      return <ModalLock offerLockData={offerLockData}>{content}</ModalLock>
    default:
      return null
  }
}

UpdatePaymentInfoLock.fragments = {
  offerLockData: gql`
    fragment UpdatePaymentInfoLock_offerLockData on OfferLockData {
      ...UpdatePaymentInfoLockContent_offerLockData
      ...UpdatePaymentInfoLockModalLock_offerLockData
      ...PaywallLock_offerLockData
    }

    ${Content.fragments.offerLockData}
    ${PaywallLock.fragments.offerLockData}
    ${ModalLock.fragments.offerLockData}
  `,
}
